import { useState, useCallback } from "react";

const STORAGE_PREFIX = "rheumhub:pref:";

interface SearchParamOptions {
  storageKey?: string;
}

export function useSearchParam(
  key: string,
  defaultValue: string = "",
  options?: SearchParamOptions
): [string, (value: string) => void] {
  const storageKey = options?.storageKey ? STORAGE_PREFIX + options.storageKey : null;

  const [value, setValue] = useState<string>(() => {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get(key);
    if (fromUrl !== null) return fromUrl;
    if (storageKey) {
      const fromStorage = localStorage.getItem(storageKey);
      if (fromStorage !== null) return fromStorage;
    }
    return defaultValue;
  });

  const setParam = useCallback((newValue: string) => {
    setValue(newValue);
    const params = new URLSearchParams(window.location.search);
    if (newValue === defaultValue || newValue === "") {
      params.delete(key);
      if (storageKey) localStorage.removeItem(storageKey);
    } else {
      params.set(key, newValue);
      if (storageKey) localStorage.setItem(storageKey, newValue);
    }
    const search = params.toString();
    const newUrl = search
      ? `${window.location.pathname}?${search}`
      : window.location.pathname;
    window.history.replaceState(null, "", newUrl);
  }, [key, defaultValue, storageKey]);

  return [value, setParam];
}
